import ServiceNotificationConfig from './ServiceNotificationConfig';

export default ServiceNotificationConfig;